import React, { useCallback } from 'react';
import { Send } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

import './css/BroadcastChatInput.css';
import './css/BroadcastChatInput.mobile.css';

import 'emoji-mart/css/emoji-mart.css';

import RichTextField from '../../PrivateChat/chat/active-conversation/messaging/RichTextField/RichTextField';

import BroadcastChatInputEmoticonPicker from './BroadcastChatInputEmoticonsPicker';

const DELAY_TO_SET_FOCUS_IN_MILLIS = 100;
const MAX_MESSAGE_LENGTH_IN_CHARS = 80;

const BroadcastChatInput = ({
  messageMetadata,
  isAnchor,
  anchorSubscriptions,
  inputMessage,
  updateInputMessage,
  onInputKeyPress,
  onMessageSend,
}) => {
  const inputRef = React.useRef(null);
  const [emoticonsPickerVisible, toggleEmoticonsPicker] = React.useState(false);
  const onEmoticonClick = React.useCallback((emoticon) => {
    inputRef.current.insert(emoticon.native);
    // we need setTimeout otherwise inputRef.current.focus() won't work
    setTimeout(() => {
      if (!isMobile) {
        inputRef.current.focus();
      }
    }, DELAY_TO_SET_FOCUS_IN_MILLIS);
  });

  const onLocalInputKeyPress = React.useCallback((event) => {
    onInputKeyPress(event);
    if (event.key === 'Enter') {
      toggleEmoticonsPicker(false);
      clearInput();
    }
  }, [onInputKeyPress, toggleEmoticonsPicker]);

  const clearInput = useCallback(() => {
    if (inputRef && inputRef.current.clear) {
      inputRef.current.clear();
    }
  }, []);


  const onLocalSendButtonClick = React.useCallback((event) => {
    clearInput();
    onMessageSend(event);
    toggleEmoticonsPicker(false);
  });

  const shouldMinimizeInputArea = useCallback(() => {
    if (inputMessage.length < 18) {
      return true;
    }

    return false;
  }, [inputMessage]);

  return (
    <div className="broadcast-chat-input-container">
      {!isMobile && (
        <BroadcastChatInputEmoticonPicker
          emoticonsPickerVisible={emoticonsPickerVisible}
          toggleEmoticonsPicker={toggleEmoticonsPicker}
          onEmoticonClick={onEmoticonClick}
        />
      )}
      <div className="send" onClick={onLocalSendButtonClick}>
        <Send fontSize="large" />
      </div>
      <div
        className={classnames('broadcast-chat-input', 'form-input-box', { 'chat-input-minimize': shouldMinimizeInputArea() })}
      >
        <RichTextField
          ref={inputRef}
          anchorSubscriptions={anchorSubscriptions}
          inputProps={{ className: 'form-text-input broadcast-chat-input-field', maxLength: MAX_MESSAGE_LENGTH_IN_CHARS }}
          isFan={!isAnchor}
          multiline={true}
          name="message"
          placeholder="Type something..."
          type="text"
          value={inputMessage}
          valueMeta={messageMetadata}
          onChange={updateInputMessage}
          onKeyDown={onLocalInputKeyPress}
        />
      </div>
    </div>
  );
};

export default BroadcastChatInput;
